import { render } from "./IconLinkedin.vue?vue&type=template&id=6d09cce2&scoped=true"
import script from "./IconLinkedin.vue?vue&type=script&lang=js"
export * from "./IconLinkedin.vue?vue&type=script&lang=js"

import "./IconLinkedin.vue?vue&type=style&index=0&id=6d09cce2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d09cce2"]])

export default __exports__